export default function Tooltip({ message, children, disabled }) {
    return (
    <div className="group relative flex mx-auto">
        {children}
        <span className={`absolute ${disabled ? 'w-20':'w-60'} top-5 z-40 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100`}>{message}</span>
    </div>
    )
}